/**
 * Volca Drum Editor - Main Entry Point
 * React + TypeScript application
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// Import design tokens
import '@midi-volca-drum/design-tokens/tokens.css';
import '@midi-volca-drum/design-tokens/tokens-light.css';

// Import UI component library styles
import '@midi-volca-drum/ui-components/styles';

// Import app-specific style overrides
import './app.css';

// Get root element
const rootElement = document.getElementById('app');

if (!rootElement) {
  throw new Error('Root element not found');
}

// Create React root and render app
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
